'use client';

import React, { useEffect, useRef } from 'react';

const cards = [
  {
    tag: 'Yours',
    title: 'One named rep, dedicated',
    body: 'You interview your SDR before launch. Full time, your account only, no pooling, no reshuffles. If we ever need to replace a rep, you approve the successor.',
  },
  {
    tag: 'Portable',
    title: 'Your playbook and domains',
    body: 'Meeting definition, sequences, and reporting live in shared documents you keep. Sending domains can sit in your tenant so reputation is never hostage again.',
  },
  {
    tag: 'Fast',
    title: 'Live in about 10 days',
    body: 'Bring your existing ICP and past campaign data. Transition setup reuses what worked, and first meetings typically land inside weeks 2 to 4.',
  },
];

export default function ContinuitySection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const els = sectionRef?.current?.querySelectorAll('.rev');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24">
      <div className="max-w-site mx-auto px-7">
        <div className="rev mb-13 max-w-[760px]">
          <div className="eyebrow">What switching looks like</div>
          <h2 className="heading-2 text-ink">Continuity by design</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {cards?.map((card, i) => (
            <div
              key={card?.tag}
              className="rev bg-white border border-line-color rounded-brand p-7"
              style={{ transitionDelay: `${i * 0.09}s` }}
            >
              <span className="block font-mono text-[11px] tracking-[0.18em] text-primary uppercase mb-3.5">
                {card?.tag}
              </span>
              <h3 className="heading-3 text-ink mb-3">{card?.title}</h3>
              <p className="text-[15px] text-muted-text leading-relaxed">{card?.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}